var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{attrs:{"loading":_vm.forceReload.loading,"small":_vm.small,"outlined":""},on:{"click":function($event){return _vm.forceReload.do()}}},[_vm._v("Reload")])
}
var staticRenderFns = []

export { render, staticRenderFns }